export const EMPLOYEE_DOCUMENT_CATEGORIES = [
  ["application_hiring", "Application & Hiring"],
  ["onboarding", "Onboarding"],
  ["legal_government_compliance", "Legal & Government Compliance"],
  ["policies_procedures", "Policies & Procedures"],
];
export const documentFilingCategory = (doc) =>
  EMPLOYEE_DOCUMENT_CATEGORIES.some(([key]) => key === doc.filing_category)
    ? doc.filing_category
    : "uncategorized";
export const filterEmployeeDocuments = (documents, category) =>
  category === "all"
    ? documents
    : documents.filter((doc) => documentFilingCategory(doc) === category);
export const DOCUMENT_FILING_FILTERS = [
  ["all", "All documents"],
  ...EMPLOYEE_DOCUMENT_CATEGORIES,
  ["uncategorized", "Uncategorized"],
];
